module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bvWSZ"))).then(() => parcelRequire('7CjLf'));